import * as Yup from "yup";
import { checkFileType, checkFileSize } from "utils/fileValidation";
import translateIntl from "../../../../i18n/translateIntl";

const initialValues = {
  name: "",
  clabe: "",
  accountNumber: "",
  origin: "",
  accountStatement: "",
  identificationFront: "",
  identificationBack: "",
};

const setFileValue = (event, name, setFieldValue) => {
  if (!event.target.files.length) {
    setFieldValue(name, "");
  } else {
    setFieldValue(name, {
      file: event.target.files[0],
    });
  }
};

const getValidationSchema = () =>
  Yup.object().shape({
    clabe: Yup.string()
      .required(translateIntl("common.requiredField"))
      .matches(/^\d+$/, { message: translateIntl("common.fieldMustBeANumber") })
      .length(18, translateIntl("common.fieldLengthMustBe", { length: 18 })),
    name: Yup.string()
      .required(translateIntl("common.requiredField"))
      .min(8, translateIntl("common.fieldLengthMustBeAtLeast", { length: 8 }))
      .max(80, translateIntl("common.fieldLengthMustBeBellow", { length: 80 })),
    accountStatement: Yup.object().shape({
      file: Yup.mixed()
        .required(translateIntl("common.requiredField"))
        .test("", translateIntl("common.errors.onlyImageFormat"), (value) =>
          checkFileType(value)
        )
        .test(
          "",
          translateIntl("common.errors.fileMaxSize", {
            size: "1.5",
            unit: "MB",
          }),
          (value) => checkFileSize(value, 1500)
        ),
    }),
    identificationFront: Yup.object().shape({
      file: Yup.mixed()
        .required(translateIntl("common.requiredField"))
        .test("", translateIntl("common.errors.onlyImageFormat"), (value) =>
          checkFileType(value)
        )
        .test(
          "",
          translateIntl("common.errors.fileMaxSize", {
            size: "1.5",
            unit: "MB",
          }),
          (value) => checkFileSize(value, 1500)
        ),
    }),
    identificationBack: Yup.object().shape({
      file: Yup.mixed()
        .required(translateIntl("common.requiredField"))
        .test("", translateIntl("common.errors.onlyImageFormat"), (value) =>
          checkFileType(value)
        )
        .test(
          "",
          translateIntl("common.errors.fileMaxSize", {
            size: "1.5",
            unit: "MB",
          }),
          (value) => checkFileSize(value, 1500)
        ),
    }),
  });

export { getValidationSchema, initialValues, setFileValue };
